import createSelector from 'selectorator';
import * as _ from 'lodash';
import type { PolicyStore } from './store';
import type { ReduxStore } from '../store';
import type { Policy } from '../../types';

const getPolicies = createSelector<ReduxStore, PolicyStore['policies']>(['policies.policies'], policies => policies);

const policySelectors = {
  getPolicies,
  getPolicyList: createSelector([getPolicies], _.values),
  getGroupedPolicies: createSelector<ReduxStore, Record<string, Policy[]>>(
    [getPolicies],
    (policies: Record<string, Policy>) => {
      const groupedPolicies = _.groupBy(Object.values(policies), (policy) => policy.type);
      return Object.fromEntries(Object.entries(groupedPolicies).map(([type, policyList]) => {
        const sortedPoliciesList = _.sortBy(policyList, (pol) => pol.title.toLowerCase());
        return [type, sortedPoliciesList];
      }));
    },
  ),
  getStatus: createSelector([`policies.status`], (status) => status),
  getCurrentPolicy: (state: ReduxStore, props: { params: { policyId: number } }) =>
    state.policies.policies[props.params.policyId],
  getExceptions: createSelector(['policies.exceptions'], (exceptions) => exceptions),
};

export default policySelectors;
